import EventPost from 'flarum/forum/components/EventPost';
export default class ListingBumpedPost extends EventPost {
  icon() {
    return 'fas fa-arrow-up';
  }
  descriptionKey() {
    return 'flarum-classifieds.forum.post_stream.listing_bumped_text';
  }
}
flarum.reg.add('ramon-classifieds', 'forum/components/ListingBumpedPost', ListingBumpedPost);